export default "__VITE_ASSET__7g0GefO4__"